(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.biosxTapPreview) {
  window.biosxTapPreview = true;
  document.addEventListener('click', event => {
    if (!matchMedia('(hover: none) and (pointer: coarse)').matches || event.detail === 0) return;
    const link = event.target.closest('.product-card__figure > a');
    const card = link?.closest('product-card[data-biosx-tap-preview]');
    if (!card || !link.querySelector('.product-card__image--secondary')) return;
    if (card.classList.contains('biosx-preview')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelectorAll('product-card.biosx-preview').forEach(item => item.classList.remove('biosx-preview'));
    card.classList.add('biosx-preview');
  }, true);
}
  } catch(e) { console.error(e); }
})();

})();
